import React, { useState } from 'react';
import { Menu, Dropdown, Drawer, Avatar, Divider, Modal } from 'antd';
import { PageHeader as AntHeader } from '@ant-design/pro-layout';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DownOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { FiLogOut } from 'react-icons/fi';

import { setSelectedOrganization } from '../redux/reducers/globals/globalActions';
import { applicationLogout } from '../services/LoginServices';
import { getFirstLetterFromWords } from 'helpers';
import { SIDE_MENUS } from 'constants/app-constants';
import EditOrganization from 'pages/organization/edit-organization';

import './pageHeaderStyle.scss';
import './drawer.scss';

const PageHeader = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [orgSettingsVisible, setOrgSettingsVisible] = useState(false);

	const { selectedOrganization, organizations } = useSelector((state) => state.globalRedux);
	const { isLogged, firstName, lastName, mobile } = useSelector((state) => state.loginRedux);

	const initials = getFirstLetterFromWords(`${firstName} ${lastName}`);

	const handleLogout = () => {
		setDrawerOpen(false);
		applicationLogout(history);
	};

	const organizationMenu = (
		<Menu>
			{organizations?.map((org) => (
				<Menu.Item
					key={org._id}
					onClick={() => {
						dispatch(setSelectedOrganization(org));
						setTimeout(() => window.location.reload(), 1000);
					}}>
					{org.orgName}
				</Menu.Item>
			))}
		</Menu>
	);

	const renderDrawerMenuItems = () =>
		SIDE_MENUS.map((menu) => {
			const Icon = menu?.icon || <MailOutlined />;
			return (
				<Menu.Item
					key={menu.key}
					icon={Icon}
					onClick={() => {
						setDrawerOpen(false);
						menu.route && history.push(menu.route);
					}}>
					{menu.name}
				</Menu.Item>
			);
		});

	if (!isLogged) return null;

	return (
		<>
			<AntHeader
				className="custom-header"
				style={{ backgroundColor: '#fff' }}
				extra={[
					<Dropdown overlay={organizationMenu} trigger={['click']} key="org">
						<a onClick={(e) => e.preventDefault()} style={{ color: 'black', marginRight: '10px' }}>
							{selectedOrganization?.orgName} <DownOutlined />
						</a>
					</Dropdown>,
					<div onClick={() => setDrawerOpen(true)} key="profile">
						<Avatar className="pointer-icons" style={{ backgroundColor: '#21B478' }}>
							{initials}
						</Avatar>
					</div>,
				]}
			/>

			<Drawer
				title={
					<div className="title-area">
						<Avatar style={{ backgroundColor: '#21B478' }}>{initials}</Avatar>
						<div className="name_role">
							<div className="name">{`${firstName} ${lastName}`}</div>
							<div className="role">{mobile}</div>
						</div>
					</div>
				}
				rootClassName="app-drawer"
				placement="right"
				open={drawerOpen}
				width="20%"
				onClose={() => setDrawerOpen(false)}
				key="drawer">
				<div className="drawer-container">
					<Menu theme="light" mode="inline">
						{renderDrawerMenuItems()}
						<Divider />
						<Menu.Item
							key="org-settings"
							icon={<SettingOutlined />}
							onClick={() => {
								setDrawerOpen(false);
								setOrgSettingsVisible(true);
							}}
						>
							Organization Settings
						</Menu.Item>
						<Menu.Item
							key="logout"
							icon={<FiLogOut />}
							className="logout-button"
							onClick={handleLogout}>
							Logout
						</Menu.Item>
					</Menu>
				</div>
			</Drawer>

			<Modal
				title="Organization Settings"
				open={orgSettingsVisible}
				onCancel={() => setOrgSettingsVisible(false)}
				footer={null}
				destroyOnClose
				width={480}
			>
				<EditOrganization
					closeModal={() => setOrgSettingsVisible(false)}
					onUpdated={(org) => {
						if (org?._id === selectedOrganization?._id) {
							dispatch(setSelectedOrganization({ ...org, _id: org._id }));
						}
					}}
				/>
			</Modal>
		</>
	);
};

export default PageHeader;
